export const encrypt = (str)=> {
    try{        
        return btoa(str)
    }catch(err){
        return str;
    }
}
export const decrypt = (str)=> {
    var regexBase64 = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var isBase64 =  regexBase64.test(str); 
    if(isBase64){
        return atob(str)
    }else{
        return null;
    }
    
    // try{
    //     return atob(str)
    // }catch(err){
    //     return str;
    // }
}

// const randomize = ()=>{
//     const arr = ["A","B","C","D","E","F","G","H","I","J"];

// }